/* eslint-disable prettier/prettier */
// import Images from './images'
export default [
  {
    rank: '1st',
    prize: '₹10,000/-'
  },
  {
    rank: '2nd',
    prize: '₹5,000/-'
  },
  {
    rank: '3rd',
    prize: '₹3,500/-'
  },
  {
    rank: '4-10',
    prize: '₹2000/-'
  },
  {
    rank: '11-25',
    prize: '₹1500/-'
  },
  {
    rank: '26-50',
    prize: '1000/-'
  },
  {
    rank: '51-100',
    prize: '400/-'
  }
];
